document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.cw-video').forEach(function (v) {
		function ready(){ v.classList.add('is-ready'); }
		if (v.readyState >= 2) ready(); // HAVE_CURRENT_DATA
		v.addEventListener('loadeddata', ready, { once:true });
	});
});